import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7jx4czv7nc: FaireBrandEntity = {
  token: "b_7jx4czv7nc",
  type: "brand",
  name: "WhyNotNatural",
  avatarUrl:
    "https://cdn.faire.com/fastly/3587080f83124534a794ae83c64c9513229863be7c659d0276eeacb23bbbbd23.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3a15ce5efdf6ef5fd98a93bd7ca37e7a4331b6c2693be8f0b633292fad8daf82.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3587080f83124534a794ae83c64c9513229863be7c659d0276eeacb23bbbbd23.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a15ce5efdf6ef5fd98a93bd7ca37e7a4331b6c2693be8f0b633292fad8daf82.jpeg",
  location: "Houston, TX, USA",
  minimumOrderDollars: 30,
  rating: 5,
  reviewCount: 31,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a wife and husband duo committed to clean supplements using research backed active ingredients.\n\nWe have strict standards when developing our products, which means we do not use any fillers in our capsules and we don't use preservatives like potassium sorbate in our liquids. Please read our standards.\n\nIn a supplement market full of synthetic fillers and preservatives, Why Not Natural?",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:50.570Z",
    importedBy: "entity-db-cli",
  },
};
